/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingExtraKeysRequest extends models.BillingSummaryBase {
    getFixupPrototypeFunction() { return BillingExtraKeysRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingExtraKeysRequest>): BillingExtraKeysRequest {
        let obj = Object.assign(new BillingExtraKeysRequest(), model);
        BillingExtraKeysRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingExtraKeysRequest>): BillingExtraKeysRequest {
        if (!model) return null;
        return BillingExtraKeysRequest.newInstance(<BillingExtraKeysRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingExtraKeysRequest) {
        if (!obj) return;

        models.BillingExtraKeysRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingExtraKeysRequest): boolean {
        if (models.BillingSummaryBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingExtraKeysRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set, the subset of keys to return
     */
    extra_keys: Array<string>;

    /**
     * If set, include values, not just keys
     */
    include_values: boolean;

}
